import * as React from 'react';
import { CommonIcons } from 'components/Icons';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { SIZE_ICON } from 'consts/data';
import { checkLinkHttps, isStringHasHTMLTags } from 'helpers';
import NewDesign from '..';
import { TooltipReactTooltip } from 'components/Tooltip/index';

const Tooltip = ({
  id = '',
  message = '',
  link = '',
  target = '_blank',
  place = 'right',
  className = '',
  style,
  ...restProps
}) => {
  //! State
  const { t } = useTranslation();

  //! Function
  const msgTooltip = React.useMemo(() => {
    const content = isStringHasHTMLTags(message) ? (
      <NewDesign.Typography dangerouslySetInnerHTML={{ __html: message }} />
    ) : (
      message
    );

    if (link) {
      const isHttpLinks = checkLinkHttps(link);
      return (
        <span>
          <p>{content}</p>
          {isHttpLinks ? (
            <a className='tooltip-link' href={link} target={target}>
              {t('shared:learn_more')}
            </a>
          ) : (
            <Link className='tooltip-link' to={link} target={target}>
              {t('shared:learn_more')}
            </Link>
          )}
        </span>
      );
    }

    return content;
  }, [t, target, message, link]);

  //! Render
  return (
    <TooltipReactTooltip
      {...restProps}
      idTarget={id}
      messageToolTip={msgTooltip}
      place={place}
      delayShow={600}
    >
      <CommonIcons.Tooltip className={className} style={style} size={SIZE_ICON + 2} />
    </TooltipReactTooltip>
  );
};

export default React.memo(Tooltip);
